import { cn } from '@/shared/utils/tw'
import Image from 'next/image'
import React from 'react'

const ProfileImage = ({ imageUrl, size = 40, className }: { imageUrl: string, size?: number, className?: string }) => {
  const hasPropsBackground = className?.includes('bg-')
  const hasPropsBorderColor = className?.includes('border-[#')
  return (
    <div className={cn("w-10 h-10 rounded-full flex items-center justify-center border border-solid overflow-hidden",
      !hasPropsBackground && 'bg-[radial-gradient(50%_50%_at_50%_50%,#FFD6D6_2.88%,#FFEAEA_71.63%,#FFFEFE_100%)]',
      !hasPropsBorderColor && 'border-[#FF9595]/15',
      className
    )}>
      <Image src={imageUrl} alt="avatar" width={size} height={size} draggable={false} />
    </div>
  )
}

export default ProfileImage